import { render, staticRenderFns } from "./AudienceModal.vue?vue&type=template&id=3ae5e000&scoped=true"
import script from "./AudienceModal.vue?vue&type=script&lang=js"
export * from "./AudienceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae5e000",
  null
  
)

export default component.exports